import { api } from '../../context/AuthContext';

// Listings ------------------------------------------------------------
export const listListings = () => api.get('/listings').then((r) => r.data);
export const createListing = (body) => api.post('/listings', body).then((r) => r.data);
export const updateListing = (id, body) => api.put(`/listings/${id}`, body).then((r) => r.data);
export const deleteListing = (id) => api.delete(`/listings/${id}`).then((r) => r.data);

// Clients -------------------------------------------------------------
export const listClients = (params = {}) =>
  api.get('/clients', { params }).then((r) => r.data);
export const createClient = (body) => api.post('/clients', body).then((r) => r.data);
export const updateClient = (id, body) => api.put(`/clients/${id}`, body).then((r) => r.data);
export const deleteClient = (id) => api.delete(`/clients/${id}`).then((r) => r.data);
export const getClientHistory = (id) => api.get(`/clients/${id}/history`).then((r) => r.data);
export const getClientsStats = () => api.get('/clients/stats').then((r) => r.data);
export const matchClients = (listing_id, threshold = 80) =>
  api.post('/clients/match', { listing_id, threshold }).then((r) => r.data);

// Appointments --------------------------------------------------------
export const listAppointments = (view = 'all') =>
  api.get('/appointments', { params: { view } }).then((r) => r.data);
export const createAppointment = (body) => api.post('/appointments', body).then((r) => r.data);
export const updateAppointment = (id, body) => api.put(`/appointments/${id}`, body).then((r) => r.data);
export const deleteAppointment = (id) => api.delete(`/appointments/${id}`).then((r) => r.data);
export const cancelAppointment = (id) => api.post(`/appointments/${id}/cancel`).then((r) => r.data);

// Trusted professionals (realtor's private rolodex) --------------------
export const listProfessionals = (category) =>
  api.get('/professionals', { params: category ? { category } : {} }).then((r) => r.data);
export const listProfessionalCategories = () =>
  api.get('/professionals/categories').then((r) => r.data);
export const createProfessional = (body) => api.post('/professionals', body).then((r) => r.data);
export const updateProfessional = (id, body) => api.put(`/professionals/${id}`, body).then((r) => r.data);
export const deleteProfessional = (id) => api.delete(`/professionals/${id}`).then((r) => r.data);

// UI helpers ----------------------------------------------------------
export const EMPTY_LISTING = {
  address: '', price: '', beds: '', baths: '', sqft: '',
  description: '', features: [], status: 'Active',
  image_url: '', source_url: '',
};

export const EMPTY_CLIENT = {
  type: 'buyer',
  name: '', email: '', phone_number: '',
  twilio_opt_in_status: 'PENDING',
  criteria: {
    min_price: null, max_price: null,
    min_beds: null, min_baths: null,
    stories: 'any', min_sqft: null,
    target_areas: [],
  },
  qualification_notes: '',
  pre_approved: false,
  tag: '',
  source: 'web',
  open_house_rsvps: [],
};

export const EMPTY_APPT = {
  source: 'web', title: '', address: '',
  client_name: '', client_phone: '',
  start: '', duration_min: 30, notes: '',
};

// Interactions ---------------------------------------------------------
export const listInteractions = () => api.get('/interactions').then((r) => r.data);
export const unreadCount = () => api.get('/interactions/unread-count').then((r) => r.data);
export const markInteractionRead = (id) =>
  api.post(`/interactions/${id}/read`).then((r) => r.data);

// Blasts ---------------------------------------------------------------
export const listBlasts = () => api.get('/blasts').then((r) => r.data);
export const createBlast = (body) => api.post('/blasts', body).then((r) => r.data);
export const rsvpBlast = (id, body) =>
  api.post(`/blasts/${id}/rsvp`, body).then((r) => r.data);
export const fairHousingCheck = (text) =>
  api.post('/fair-housing/check', { text }).then((r) => r.data);
